module.exports = {
  messages: {
    CN: {
      PaymentPending: "您有一条campaign已排期。",
      unpaidOrder: "如需发布，请绑定信用卡继续使用免费版，或升级至付费套餐。",
      Draft: "草稿",
      Createtime: "创建时间",
      Paynow: "前往发布",
      Editcampaign: "编辑推广活动",
       bindModalTitlePrefix: "还差最后一步 —— ",
      bindModalTitleMatch: "",
      bindModalTitleSuffix: " 正在等待联系",
      bindModalMatchedCustomer: "位客户",
      bindModalMatchedCandidate: "位候选人",
      bindModalStatsCustomerMatched: "位客户已匹配",
      bindModalStatsCandidateMatched: "位候选人已匹配",
      bindModalDesc:
        "您的活动已全部配置完毕（LinkedIn 已连接、受众已匹配、消息已就绪）",
      bindModalDescBold: "立即发布即可开启。",
      bindModalPendingBadge: "待发布",
      bindModalStatsSuffix: " 位候选人已匹配",
      bindModalStatsReplies: "首轮回复预计 ~1-3 天",
      bindModalStatsCreated: "创建于 {date}",
      bindModalNoticePrefix: "发布即开启您的 ",
      bindModalNoticeBold: "10 天免费试用",
      bindModalNoticeSuffix: "（今天 $0）；第 10 天前可随时取消，零费用。",
      bindModalContinueBtn: "继续 · 先看看会带来什么",
      bindModalEditBtn: "编辑活动",
    },

    US: {
      PaymentPending: "You have a campaign scheduled.",
      unpaidOrder:
        "To publish it, please add your credit card to continue using the free plan, or upgrade to a paid plan.",
      Draft: "Draft",
      Createtime: "Create time",
      Paynow: "Go to Publish",
      Editcampaign: "Edit campaign",
      bindModalTitlePrefix: "One step left — ",
      bindModalTitleMatch: "",
      bindModalTitleSuffix: " are waiting to be contacted",
      bindModalMatchedCustomer: "customers",
      bindModalMatchedCandidate: "candidates",
      bindModalStatsCustomerMatched: "customers matched",
      bindModalStatsCandidateMatched: "candidates matched",
      bindModalDesc:
        "Your campaign is fully configured (LinkedIn connected, audience matched, messaging ready)",
      bindModalDescBold: "publish to begin.",
      bindModalPendingBadge: "Pending launch",
      bindModalStatsSuffix: " candidates matched",
      bindModalStatsReplies: "first replies in ~1-3 days",
      bindModalStatsCreated: "created {date}",
      bindModalNoticePrefix: "Publishing starts your ",
      bindModalNoticeBold: "10-day free trial",
      bindModalNoticeSuffix:
        " ($0 today); cancel anytime before day 10 and pay nothing.",
      bindModalContinueBtn: "Continue · see what it’ll deliver first",
      bindModalEditBtn: "Edit campaign",
    },
    AR: {
      PaymentPending: "لديك حملة مجدولة.",
      unpaidOrder:
        "لنشرها، يرجى إضافة بطاقتك الائتمانية لمواصلة استخدام الخطة المجانية، أو الترقية إلى خطة مدفوعة.",
      Draft: "مسودة",
      Createtime: "وقت الإنشاء",
      Paynow: "انتقل إلى النشر",
      Editcampaign: "تعديل الحملة",
      bindModalTitlePrefix: "لم يتبقَّ سوى خطوة واحدة — ",
      bindModalTitleMatch: "",
      bindModalTitleSuffix: " ينتظرون التواصل معهم",
      bindModalMatchedCustomer: "عملاء",
      bindModalMatchedCandidate: "مرشحين",
      bindModalStatsCustomerMatched: "عملاء متطابقون",
      bindModalStatsCandidateMatched: "مرشّحون مطابقون",
      bindModalDesc:
        "تمّ ضبط حملتك بالكامل (تمّ ربط LinkedIn ومطابقة الجمهور وتجديد الرسائل جاهزة)",
      bindModalDescBold: "انشر لتبدأ.",
      bindModalPendingBadge: "في انتظار الإطلاق",
      bindModalStatsSuffix: " مرشّح مطابق",
      bindModalStatsReplies: " الردود الأولى خلال ~1-3 أيام",
      bindModalStatsCreated: "تمّ الإنشاء في {date}",
      bindModalNoticePrefix: "بدء النشر يُفعّل ",
      bindModalNoticeBold: "تجربتك المجانية لمدة 10 أيام",
      bindModalNoticeSuffix:
        " (0$ اليوم)؛ يمكنك الإلغاء في أي وقت قبل اليوم 10 بدون أي رسوم.",
      bindModalContinueBtn: "متابعة · شاهد ما ستحصل عليه أوّلاً",
      bindModalEditBtn: "تعديل الحملة",
    },
  },
};
